import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/scss/main.scss";
import Maska from "maska";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import loading from "@/components/loading";
import l2c from "@/utils/lat2cyr";
import extract from "@/utils/extract-content";
import VuePageTitle from "vue-page-title";
import ApiConfig from "@/utils/api-config";
import i18n from "./i18n";

Vue.use(VuePageTitle, {
  // prefix: 'My App - ',
  suffix: "- Universalbank akademiyasi",
});
Vue.use(ApiConfig);
Vue.directive("cyr2lat", l2c);
Vue.directive("extract", extract);
Vue.component("v-loader", loading);
Vue.use(Vuelidate);
Vue.use(VueAxios, axios);
Vue.use(Maska);
Vue.config.productionTip = false;
window.addEventListener("load", async () => {
  window.oncontextmenu = function () {
    return false;
  };
  if ("serviceWorker" in navigator) {
    try {
      await navigator.serviceWorker.register("/sw.js");
    } catch (e) {
      console.log(e);
    }
  }
  await loadPosts();
});
async function loadPosts() {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
}
